export default __webpack_public_path__ + "static/media/laram3.d97d1133.jpg";